// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type UseExportQueryQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.PageModelInput>;
  query?: Types.InputMaybe<Types.OcExportQueryModelInput>;
  sort?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.OcExportSortModelInput>> | Types.InputMaybe<Types.OcExportSortModelInput>
  >;
}>;

export type UseExportQueryQuery = {
  exports: {
    totalPages?: number | null;
    totalElements?: number | null;
    size?: number | null;
    content?: Array<ExportContentModelFragmentFragment | null> | null;
  };
};

export type UseExportQueryTotalCountQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UseExportQueryTotalCountQuery = {
  exports: { totalPages?: number | null; totalElements?: number | null; size?: number | null };
};

export type ExportContentModelFragmentFragment = {
  ownerUid?: string | null;
  status?: Types.OcExportStatusModel | null;
  name?: string | null;
  sourceType?: Types.OcReportSourceTypeModel | null;
  requestedFrom?: string | null;
  resourceLocation?: string | null;
  requestedTime?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  initialTotalCount?: number | null;
  failureReason?: string | null;
  exportType?: Types.OcExportTypeModel | null;
  executionId: number;
  resourceUid?: string | null;
  totalCount?: number | null;
  targetSftpDirectory?: string | null;
  filenames?: Array<string | null> | null;
  properties?: Array<{ propertyName?: Types.OcExportPropertiesKey | null; value: boolean } | null> | null;
};

export const ExportContentModelFragmentFragmentDoc = gql`
    fragment exportContentModelFragment on OcExportModel {
  ownerUid
  status
  name
  sourceType
  requestedFrom
  resourceLocation
  requestedTime
  startTime
  endTime
  initialTotalCount
  failureReason
  exportType
  executionId
  resourceUid
  totalCount
  properties {
    propertyName
    value
  }
  targetSftpDirectory
  filenames
}
    ` as unknown as DocumentNode<ExportContentModelFragmentFragment, unknown>;
export const UseExportQueryDocument = gql`
    query useExportQuery($page: PageModelInput, $query: OcExportQueryModelInput, $sort: [OcExportSortModelInput]) {
  exports(page: $page, query: $query, sort: $sort) {
    content {
      ...exportContentModelFragment
    }
    totalPages
    totalElements
    size
  }
}
    ${ExportContentModelFragmentFragmentDoc}` as unknown as DocumentNode<
  UseExportQueryQuery,
  UseExportQueryQueryVariables
>;
export const UseExportQueryTotalCountDocument = gql`
    query useExportQueryTotalCount {
  exports {
    totalPages
    totalElements
    size
  }
}
    ` as unknown as DocumentNode<UseExportQueryTotalCountQuery, UseExportQueryTotalCountQueryVariables>;
